export default function () {
  // noop: we need this to prevent the import of react-native-sha256
}
